import { render, staticRenderFns } from "./PrizeConfig.vue?vue&type=template&id=04447246"
import script from "./PrizeConfig.vue?vue&type=script&lang=js"
export * from "./PrizeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports